/** Split an array into chunks of at most `chunkSize` items. A size below 1 is treated as 1. */
export function chunkArray<T>(array: readonly T[], chunkSize = 1): T[][] {
  const size = Math.max(chunkSize, 1);
  const results: T[][] = [];
  for (let index = 0; index < array.length; index += size) {
    results.push(array.slice(index, index + size));
  }
  return results;
}
